import { Entities } from '@app/store/activities/secondaryFilter';

import { SYSTEM_ATTRIBUTE_SCHEMA_NAMES } from '../manageLeads/leadAttributes';

export const ACTIVITY_SYSTEM_SCHEMA_NAMES = {
  activityTime: 'ActivityTime',
  createdById: 'CreatedById',
  updatedById: 'ModifiedById',
  status: 'Status',
  owner: 'OwnerId',
  activityNote: 'ActivityNote',
};

export const ACTIVITIES_TYPES = {
  all: 'all',
  custom: 'custom',
  system: 'system',
} as const;

export type ActivitiesType = typeof ACTIVITIES_TYPES[keyof typeof ACTIVITIES_TYPES];

export const ACTIVITIES_TYPES_NAMES: Record<ActivitiesType, string> = {
  [ACTIVITIES_TYPES.all]: 'All',
  [ACTIVITIES_TYPES.custom]: 'User Activities',
  [ACTIVITIES_TYPES.system]: 'System Activities',
} as const;

export const NUM_ACTIVITIES_TO_FETCH = 5 as const;

export const ALL_ACTIVITIES_OPTION = {
  label: 'All Activities',
  value: 'all',
};

export const HIDDEN_FIELDS_FOR_ACTIVITY_CREATE = [
  ACTIVITY_SYSTEM_SCHEMA_NAMES.createdById,
  ACTIVITY_SYSTEM_SCHEMA_NAMES.updatedById,
];

export const ACTIVITY_DEFAULT_VISIBLE_ACTIVITY_COLUMNS = [
  ACTIVITY_SYSTEM_SCHEMA_NAMES.activityNote,
  ACTIVITY_SYSTEM_SCHEMA_NAMES.owner,
  ACTIVITY_SYSTEM_SCHEMA_NAMES.activityTime,
  ACTIVITY_SYSTEM_SCHEMA_NAMES.status,
];

export const ACTIVITY_DEFAULT_VISIBLE_LEAD_COLUMNS = [
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.email,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.owner,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.leadAge,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.ownerEmail,
  SYSTEM_ATTRIBUTE_SCHEMA_NAMES.leadStage,
];

export const DEFAULT_SORT_CONFIG = {
  sortField: ACTIVITY_SYSTEM_SCHEMA_NAMES.activityTime,
  sortOrder: 'desc',
};

export const ACTIVITIES_ADVANCED_SEARCH_ENTITY_KEY = 'activities' as const;

export const DEFAULT_LEAD_ATTRIBUTES = ACTIVITY_DEFAULT_VISIBLE_LEAD_COLUMNS.map(
  (schemaName) => `${Entities.LeadAttributes}.${schemaName}`,
);

export const DEFAULT_ACTIVITY_ATTRIBUTES = ACTIVITY_DEFAULT_VISIBLE_ACTIVITY_COLUMNS.map(
  (schemaName) => `${Entities.LeadActivity}.${schemaName}`,
);
